/**
 * Creates a keyboard activation handler for Enter and Space keys
 * Commonly used for making non-button elements keyboard accessible
 *
 * @param {Function} onActivate - Callback function to execute when Enter or Space is pressed
 * @returns {Function} Event handler to attach to onKeyDown
 *
 * @example
 * const handleActivation = createKeyboardActivationHandler(() => {
 *   console.log('Activated!');
 * });
 *
 * <div onKeyDown={handleActivation} tabIndex={0}>Click me</div>
 */
export const createKeyboardActivationHandler = (onActivate) => {
  return (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onActivate();
    }
  };
};
